import { SideNav } from "shared/Components/sidenav";
import { Navigate, Route, Routes } from "react-router-dom";
import { globalVariables } from "helper/globalVariables";
import {
  BarChart,
  CalendarIcon,
  Edit,
  Plus,
  UploadCloud,
  Star,
  JudgeUser,
  SwitchRole,
  GenerateReports,
  ManageUsers,
  ManangeDogs,
} from "helper/images";
import { globalClasses } from "helper/globalClasses";
import { ViewJudges } from "container/Host/ViewJudges";
import { Dashboard } from "container/Host/Dashboard";
import { TrialDraw } from "container/Host/TrialDraw";
import { TrialDetails } from "container/TrialCalendar";
import TrialRegisterDogsEnrties from "container/Host/TrialCalendar/TrialRegisterDogs"
import GenerateReportsScreen from "container/SuperAdmin/ReportsManagement";
import { UploadTrialResults } from "container/Host/UploadTrialResults";
import { EditSit } from "container/Host/EditSit";
import { TrialCalendar } from "container/Host/TrialCalendar";
import { Upload } from "container/Host/Upload";
import { AddTrial } from "container/Host/AddTrial";
import { useMediaQuery } from "react-responsive";
import { MobileHeader } from "shared/Components/mobileHeader";
import { MyProfile } from "container/MyProfile";
import SuperAdminDashboard from "container/SuperAdmin/Dashboard";
import { DogHistory } from "container/DogHistory";
import { LoaderProvider } from "container/MyProfile/Context/EditAndLoaderContext";
import TrialResultDetails from "container/TrialResults/Components/TrialResultDetails";
import { ManageUsers as ManageUsersScreen } from "container/SuperAdmin/ManageUsers";
import { DetailsOfDog } from "container/SuperAdmin/ManageDogs/DetailsOfDogs";

export const HostRoutes = () => {
  const { menuIcon } = globalClasses;
  const isMobile = useMediaQuery({ query: "(max-width: 480px)" });
  const isTablet = useMediaQuery({
    query: "(max-width: 1023px) and (min-width: 480px)",
  });

  const sideNavData = [
    {
      icon: <CalendarIcon className={menuIcon} />,
      label: globalVariables.trialCalendar,
      navigate: "/host/trialCalendar",
    },
    {
      icon: <Plus className={menuIcon} />,
      label: globalVariables.addTrial,
      navigate: "/host/addTrial",
    },
    {
      icon: <Star className={menuIcon} />,
      label: globalVariables.trialDraw,
      navigate: "/host/trialDraw",
    },
    {
      icon: <UploadCloud className={menuIcon} />,
      label: globalVariables.uploadTrialResults,
      navigate: "/host/uploadTrialResults",
    },
    {
      icon: <GenerateReports className={menuIcon} />,
      label: globalVariables.generateReport,
      navigate: "/host/trial/reports",
    },
    {
      icon: <BarChart className={menuIcon} />,
      label: globalVariables.analytics,
      navigate: "/host/analytics",
    },
    {
      icon: <ManageUsers className={menuIcon} />,
      label: globalVariables.viewMembers,
      navigate: "/host/users",
    },
    {
      icon: <ManangeDogs className={menuIcon} />,
      label: globalVariables.viewDogs,
      navigate: "/host/dogs",
    },
    {
      icon: <JudgeUser className={menuIcon} />,
      label: globalVariables.viewJudges,
      navigate: "/host/viewJudges",
    },
    // {
    // 	icon: <Member className={menuIcon} />,
    // 	label: globalVariables.viewJudges,
    // 	navigate: "/host/viewJudges",
    // },
    // {
    // 	icon: <Star className={menuIcon} />,
    // 	label: globalVariables.trialDraw,
    // 	navigate: "/host/trialDraw",
    // },
    {
      icon: <Edit className={menuIcon} />,
      label: globalVariables.editSit,
      navigate: "/host/editSit",
    },

    {
      icon: <SwitchRole className="h-6 w-6 mr-3" />,
      label: "Switch-Roles",
      navigate: "/host/switchRole?option=switchRole",
      active: "/host/profile?option=switchRole",
    },
  ];

  return (
    <div>
      {!isMobile && !isTablet ? (
        <SideNav menuItems={sideNavData} profileRoute={"/host/profile"} />
      ) : (
        <MobileHeader menuItems={sideNavData} profileRoute={"/host/profile"} />
      )}

      <Routes>
        <Route path="/trialCalendar/*" element={<TrialCalendar />} />
        <Route path="/analytics/*" element={<SuperAdminDashboard />} />
        <Route path="/switchRole" element={<MyProfile />} />
        <Route
          path="/profile"
          element={
            <LoaderProvider>
              <MyProfile isHost={true} />
            </LoaderProvider>
          }
        />
        <Route path="/addTrial/*" element={<AddTrial />} />
        <Route path="/trialCalendarEditTrial/*" element={<AddTrial isEdit />} />
        <Route path="/viewJudges/*" element={<ViewJudges />} />
        <Route path="/analytics/*" element={<Dashboard />} />
        <Route path="/trialDraw/*" element={<TrialDraw />} />
        <Route path="/trialDetails/:id/*" element={<TrialDetails />} />
        <Route path="/viewEntries/:id/*" element={<TrialRegisterDogsEnrties />} />
        <Route path="/uploadTrialResults/*" element={<UploadTrialResults />} />
        <Route path="/users" element={<ManageUsersScreen editable={false} />} />
        <Route path="/dogs" element={<DetailsOfDog editable={false} />} />
        <Route
          path="/uploadTrialResults/:id/*"
          element={<TrialResultDetails isUpload />}
        />
        <Route path="/editSit/*" element={<EditSit />} />
        <Route
          path="/editSiteDetails/:id/*"
          element={<DogHistory isAdmin={false} host={true} />}
        />
        <Route path="/upload/*" element={<Upload />} />
        <Route
          path="/"
          element={<Navigate to="/host/trialCalendar/" replace />}
        />{" "}
        <Route
          path="/trial/reports"
          element={<GenerateReportsScreen isHost />}
        />
      </Routes>
    </div>
  );
};
